var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-6 col-lg-3" },
        [
          _c("view-mode-selector", {
            on: { "on-viewmode-changed": _vm.onViewModeChanged },
            model: {
              value: _vm.currentViewMode,
              callback: function($$v) {
                _vm.currentViewMode = $$v
              },
              expression: "currentViewMode"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-12 col-md-6 col-lg-9" },
        [_vm._t("filters")],
        2
      )
    ]),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("view-data-range-selector", {
          attrs: { "view-mode": _vm.currentViewMode, year: _vm.year },
          on: { "on-datarange-changed": _vm.onDatarangeChanged }
        })
      ],
      1
    ),
    _c("div", { staticClass: "row" }, [_vm._t("details")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }